import { NamedNode } from './node';

export class Lock extends NamedNode {
  serialnr?: string;
  identity?: any;
  state?: any;
}
